define((require) => {
    "use strict";

    const SceneNavigatorWidgetView = require("shared/ui/experience/widgets/sceneNavigatorWidget/SceneNavigatorWidgetView");
    /**
     * Mixin the editor related logic for the <tt>SceneNavigatorWidgetView</tt>.
     *
     * @see  SceneNavigatorWidgetView
     */
    return SceneNavigatorWidgetView.mixin("SceneNavigatorWidgetViewEditorMixin", {
        /**
         * This method is extends and changes the highlight
         * of the widget astract method `_updateHightlight`
         */
        applyWidgetSpecificHighlight() {
            // Highlight widget if required
            if (this.model.get("highlighted")) {
                this.$el.css({
                    background: "rgba(255,255,255,0.75)",
                    boxShadow: "inset 0px 0px 0px 3px #8c01ff"
                });
            } else if (!this.model.get("boxShadow")) {
                this.$el.css({
                    boxShadow: "inset 0px 0px 0px 0px transparent"
                });
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/sceneNavigatorWidget/SceneNavigatorWidgetViewEditorMixin.js